<template>
    <div class="produto-container">
        <loader v-if="isLoading" />
        <div class="columns">
            <div class="column is-6">
                <search-bar :onSearch="debouncedOnSearch" tooltipLabel="msg-campo-busca-contrato" />
            </div>

            <div class="column is-3">
                <vss-select
                    ref="situacaoSelect"
                    :searchable="false"
                    :options="situacaoSelect"
                    v-model="situacaoSelected"
                    mlLabels
                    title="situacao"
                    clearable
                    @input="onSituacaoChanged"
                    :height="40"
                />
            </div>
            <div class="column is-3">
                <button class="save-btn botao-acao" type="button" @click="showModal = true">
                    {{ $t('vincular') }} {{ $t('produto') }}
                </button>
            </div>
        </div>
        <div class="produto-list">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="produtoList"
                class="data-table"
                @sort="sortTable"
                backend-sorting
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :width="f.width"
                    :label="f.key != 'excluir' ? $t(f.key) : ''"
                    :class="{
                        'excluir-field': f.key == 'excluir',
                    }"
                    :sortable="f.sortable"
                    v-slot="props"
                >
                    <div v-if="f.key == 'codigo'">
                        {{ props.row['idcontratoproduto'] }}
                    </div>
                    <div v-else-if="f.key == 'produto'">
                        {{ props.row.produto['descricao'] }}
                    </div>
                    <div v-else-if="f.key == 'codigobarra'">
                        {{ props.row.produto['codigobarra'] }}
                    </div>
                    <div v-else-if="f.key == 'situacao'">
                        <b-tag
                            class="table-tag table-tag-full-width"
                            :type="props.row['situacao'] == 1 ? 'is-success' : 'is-danger'"
                            size="is-medium"
                        >
                            {{ $t(props.row['situacao'] == 1 ? 'ativo' : 'inativo') }}
                        </b-tag>
                    </div>
                    <div v-else-if="f.key == 'excluir'" class="no-strike">
                        <b-button
                            v-if="permissao.delete"
                            class="action-button"
                            :type="props.row['situacao'] == 1 ? 'is-danger' : 'is-success'"
                            :icon-right="props.row['situacao'] == 1 ? 'delete' : 'check'"
                            @click="promptChangeSituacao(props.row)"
                            v-tippy 
                            :title="$t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')"
                        />
                    </div>
                    <div v-else>
                        {{ props.row[f.key] }}
                    </div>
                </b-table-column>
            </b-table>
        </div>
        <PaginationViewer
            class="mb-0"
            :resetPagination="pagination.resetPagination"
            :totalItems="pagination.totalRows"
            :perPageOptions="pagination.perPageOptions"
            :optionStarted="pagination.optionStarted"
            @change="updatePagination"
        />
        <b-modal :active.sync="showModal">
            <div class="bg">
                <ProProdutoModal
                    :idcontrato="idcontrato"
                    :tipo="tipo"
                    @fecharModal="
                        showModal = false;
                        carregarDados();
                        $emit('reloadData', true);
                    "
                />
            </div>
        </b-modal>
    </div>
</template>

<script>
import ProContratoProdutoService from '@/services/promotor/pro_cliente/ProContratoProdutoService.js';
import ProProdutoModal from '@/components/promotor/cliente/abas/contrato/modal/ProProdutoModal.vue';

export default {
    props: {
        idcontrato: {
            type: Number,
            default: 0,
        },
        tipo: {
            type: String,
            default: 'R',
        },
        permissao: {
            type: Object,
            default: () => {},
        },
        reloadData: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        ProProdutoModal,
    },
    data() {
        return {
            service: new ProContratoProdutoService(this.$http, this.$router),

            produtoList: [],
            searchQuery: '',
            delete: null,
            isEmpty: false,
            isLoading: false,
            isSaving: false,
            fields: [
                { key: 'codigo', width: null, sortable: true },
                { key: 'produto', width: null, sortable: true },
                { key: 'codigobarra', width: null, sortable: true },
                { key: 'situacao', width: 80, sortable: true },
                { key: 'excluir', width: 20, sortable: false },
            ],
            showModal: false,
            situacaoSelected: { id: 2, label: 'todos' },
            situacaoSelect: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
                column: 'descricao',
                order: 'asc',
            },
        };
    },
    watch: {
        reloadData(val) {
            if (val) {
                this.carregarDados();
            }
        },
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);

        this.carregarDados();
    },
    methods: {
        onSearch(value) {
            this.searchQuery = this.removeToSearch(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.pagination.column = field;
            this.pagination.order = order;
            this.carregarDados();
        },
        mapContratoProduto(body) {
            this.pagination.totalRows = body.totalElements;

            let list = body.content.map((i) => {
                return {
                    ...i,
                    excluir: 'excluir',
                };
            });
            return list;
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.service
                .findAllByContrato(
                    this.pagination.column,
                    this.pagination.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacaoSelected.id,
                    this.idcontrato,
                    this.tipo,
                    this.searchQuery
                )
                .then(this.mapContratoProduto)
                .then((value) => {
                    this.produtoList = value;
                    this.isEmpty = this.produtoList.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.produtoList = [];
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                    this.$emit('reloadData', false);
                });
        },
        promptChangeSituacao(row) {
            this.delete = row;
            // Aviso dinâmico passado o nome do usuário
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirma-desativar-ass-n'
                        : 'msg-confirma-reativar-ass-n', 
                    { n: row.produto['descricao'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: (_) => this.updateSituacao(),
                onCancel: (_) => (this.delete = null),
            });
        },
        updateSituacao() {
            let tempAss = {
                idcontratoproduto: this.delete.idcontratoproduto,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.service
                .updateSituacao(tempAss)
                .then((r) => {
                    if (r.status == 200) {
                        // Aviso dinâmico passado o nome
                        let tempSuccess = this.$t(
                                this.delete.situacao == 1
                                    ? 'msg-sucesso-ao-reativar-ass-n'
                                    : 'msg-sucesso-ao-desativar-ass-n', 
                                { n: this.delete.produto.descricao }
                            );

                        this.$root.showMessage('success', tempSuccess, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    // Aviso dinâmico passado o nome
                    let msg = this.$t(
                            this.delete.situacao == 0
                                ? 'msg-erro-ao-desativar-ass-n'
                                : 'msg-erro-ao-reativar-ass-n', 
                            { n: this.delete.nome }
                        );

                    this.$root.showMessage('error', msg, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.produto-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 250px;
    .produto-list {
        flex-grow: 1;
        color: #fff;
    }
}
.botao-acao {
    margin-top: 24px;
    width: 100%;
    height: 40px;
}

@media (max-width: 760px) {
    .botao-acao {
        margin-top: 15px;
    }
}
</style>
